import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "card-body p-3"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12 table-responsive" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "text-danger fw-bold" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "text-danger fw-bold" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/clientesDependentesService";
import * as contratosService from "@/services/clientesContratosService";
import * as planosItensService from "@/services/planosItensService";
import {fdata, fdataUS} from "@/utils/funcoes";
import { useAcl } from "vue-simple-acl";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";

interface IProps {
  ClienteId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesDependentes',
  props: {
    ClienteId: {}
  },
  setup(__props: any) {


//vue
const acl = useAcl();

function calcIdade(dataNascimento: string | null): number | null {
  if (!dataNascimento) return null;
  const nascimento = new Date(dataNascimento);
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const aindaNaoFezAniversario =
    hoje.getMonth() < nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate());
  if (aindaNaoFezAniversario) idade--;
  return idade;
}

//componentes
var props = __props;

  var controle = reactive({
    clienteId: props.ClienteId as number | null | undefined,
    itens: [] as service.Dependente[],
    itensAdicionais: [] as planosItensService.PlanoItem[],
    model: {
      clienteId: props.ClienteId,
      planoItemId: null
    } as service.Dependente,
    janela: false,
    janPergunta:false,
    erro: "",
    status: ""
  })

  onMounted(() => {

    buscarItems();
    buscarItensAdicionais();

  });

  watch(() => props.ClienteId, (newValue) => {
    controle.clienteId = newValue;
    controle.model.clienteId = newValue ?? 0;
    buscarItems();
    buscarItensAdicionais();
  });

  async function buscarItensAdicionais() {

    controle.itensAdicionais = [];

    if (!props.ClienteId) return;

    contratosService.obterContratosPorCliente(props.ClienteId)
      .then((contratos) => {
        const contrato = contratos && contratos.length > 0 ? contratos[0] : null;
        if (!contrato || !contrato.planoId) return;

        planosItensService.obter({ planoId: contrato.planoId } as planosItensService.Filtros)
          .then((itens) => {
            controle.itensAdicionais = itens;
          })
          .catch(() => { controle.itensAdicionais = []; });
      })
      .catch(() => { controle.itensAdicionais = []; });
  }

  function descricaoAdicional(planoItemId: number | null): string {
    if (!planoItemId) return "-";
    const item = controle.itensAdicionais.find(a => a.planoItemId === planoItemId);
    return item ? item.descricao : "-";
  }

  async function buscarItems() {

      if (!props.ClienteId) {
        controle.itens = [];
        return;
      }

      controle.status = "Buscando items...";
      controle.erro = "";
      service.obter({clienteId: props.ClienteId} as service.Filtros)
      .then((dependentes) => {
        controle.itens = dependentes;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }
      
  async function salvar() {

      controle.status = "Salvando item...";
      controle.erro = "";

      if (controle.model.dataNascimento != null) {
        controle.model.dataNascimento = fdataUS(controle.model.dataNascimento);
      }

      controle.model.clienteId = controle.clienteId ?? 0;

      service.salvar(controle.model)
      .then(() => {
        controle.status = "";
        controle.model = {
          clienteId: controle.model.clienteId,
          dependenteId: 0,
          nome: "",
          dataNascimento: null,
          cpf: "",
          celular: "",
          planoItemId: null
        } as service.Dependente;
        buscarItems();
        controle.janela = false;
      })
      .catch((error) => {
        controle.erro = `Erro ao salvar item: ${error}`;
        controle.status = "";
      });
  }

  function excluir(item: service.Dependente) {
    controle.model = item;
    controle.janPergunta = true;
  }

  function excluirConfirma()
  {
    controle.janPergunta = false;
    controle.status = "Excluindo item...";
    controle.erro = "";

    service.excluir(controle.model.dependenteId)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,
        dependenteId: 0,
        nome: "",
        dataNascimento: null,
        cpf: "",
        celular: "",
        planoItemId: null
      } as service.Dependente;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Dependentes")
          ], -1)),
          (!_unref(props).ClienteId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("p", { class: "" }, "Necessário cadastro do cliente")
                  ])
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).janela = true))
                    }, "Adicionar")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Parentesco"),
                          _createElementVNode("th", null, "Nome"),
                          _createElementVNode("th", null, "Nascimento"),
                          _createElementVNode("th", null, "Idade"),
                          _createElementVNode("th", null, "CPF"),
                          _createElementVNode("th", null, "Celular"),
                          _createElementVNode("th", null, "Adicional"),
                          _createElementVNode("th", null, "Ações")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(item.parentesco), 1),
                            _createElementVNode("td", null, _toDisplayString(item.nome), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataNascimento)), 1),
                            _createElementVNode("td", null, _toDisplayString(calcIdade(item.dataNascimento) ?? '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(item.cpf), 1),
                            _createElementVNode("td", null, _toDisplayString(item.celular), 1),
                            _createElementVNode("td", null, _toDisplayString(descricaoAdicional(item.planoItemId)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-primary me-1",
                                title: "Alterar registro",
                                onClick: ($event: any) => {_unref(controle).model = item; _unref(controle).janela = true}
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                              ]))], 8, _hoisted_9),
                              (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-danger",
                                    title: "Excluir registro",
                                    onClick: ($event: any) => (excluir(item))
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                  ]))], 8, _hoisted_10))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(controle).status), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(controle).erro), 1)
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createVNode(MsgBox, {
          id: 'janAddDep',
          class: "modal-md",
          "data-bs-backdrop": "static",
          exibir: _unref(controle).janela,
          titulo: 'Cadastro de Dependente',
          onOnFechou: _cache[7] || (_cache[7] = ($event: any) => (_unref(controle).janela = false)),
          "botao-gravar": true,
          "botao-fechar": true,
          onOnGravar: _cache[8] || (_cache[8] = ($event: any) => (salvar()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3" }, " Parentesco ", -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.parentesco) = $event)),
                  class: "form-select form-select-sm"
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("option", { value: null }, "- Selecione - ", -1),
                  _createElementVNode("option", { value: "Filho" }, "Filho", -1),
                  _createElementVNode("option", { value: "Filha" }, "Filha", -1),
                  _createElementVNode("option", { value: "Pai" }, "Pai", -1),
                  _createElementVNode("option", { value: "Mae" }, "Mãe", -1),
                  _createElementVNode("option", { value: "Neto" }, "Neto", -1),
                  _createElementVNode("option", { value: "Neta" }, "Neta", -1),
                  _createElementVNode("option", { value: "Conjuge" }, "Conjuge", -1)
                ]))], 512), [
                  [_vModelSelect, _unref(controle).model.parentesco]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, " Nome ", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.nome,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.nome) = $event)),
                  formato: 'Texto'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-3" }, " Dt Nascimento ", -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.dataNascimento,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.dataNascimento) = $event)),
                  formato: 'Data'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-3" }, " CPF ", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.cpf,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.cpf) = $event)),
                  formato: 'CpfCnpj'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, " Celular ", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.celular,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.celular) = $event)),
                  formato: 'Telefone'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, " Adicional ", -1)),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.planoItemId) = $event)),
                  class: "form-select form-select-sm"
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "- Nenhum -", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itensAdicionais, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.planoItemId,
                      value: item.planoItemId
                    }, _toDisplayString(item.descricao), 9, _hoisted_29))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(controle).model.planoItemId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(controle).status), 1),
                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(controle).erro), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["exibir"])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPerguntaDependente',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[9] || (_cache[9] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[10] || (_cache[10] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})